import React from "react"
import { withRouter } from "react-router-dom"
import { createRequest } from "utils/request-helper"
import { getCamperInfo } from "utils/camper-utils"
import {
  TableBody,
  TableContainer,
  TableHeader,
  TableHeaderCell,
  TableRow,
  TableRowCell,
} from "containers/Table"

import HeaderTabContainer from "containers/HeaderTabContainer"
import HeaderTab from "components/HeaderTab"

import { ArchiveRequest, EmailUserButton } from "./index"

export class CampInfoRequestsLoaded extends React.Component {
  constructor(props) {
    super(props)
    this.archiveOrActivate = this.archiveOrActivate.bind(this)
  }

  archiveOrActivate(id, filter) {
    let keyword = filter === "active" ? "archive" : "activate"
    if (
      window.confirm("Are you sure you want to " + keyword + " this request?")
    ) {
      createRequest(
        {
          method: "PATCH",
          route: `info_requests/${id}`,
          data: {
            data: {
              type: "info_requests",
              attributes: {
                archived: filter === "active" ? true : false,
              },
            },
          },
        },
        response => {
          if (response.status === 200) {
            this.props.history.push(`/info_requests/${filter}`)
          }
        },
        error => console.error(error)
      )
    }
  }

  renderInfoRequestTable(data, included, filter) {
    return (
      <TableContainer>
        <TableHeader>
          <TableHeaderCell>User Name</TableHeaderCell>
          <TableHeaderCell>Email</TableHeaderCell>
          <TableHeaderCell>Children</TableHeaderCell>
          <TableHeaderCell>Archive?</TableHeaderCell>
        </TableHeader>

        {this.renderTableBody(data, included, filter)}
      </TableContainer>
    )
  }

  renderTableBody(data, included, filter) {
    return (
      <TableBody>
        {data.map((row, i) => {
          let userId = row.relationships.user.data.id
          let userAttributes = included.filter(user => {
            return user.type === "users" && user.id === userId
          })[0].attributes

          let campers = included.filter(camper => {
            return (
              camper.type === "campers" &&
              camper.relationships.user.data.id === userId
            )
          })

          let userName =
            userAttributes["first-name"] + " " + userAttributes["last-name"]
          let userEmail = userAttributes.email

          return (
            <TableRow key={i}>
              <TableRowCell>{userName}</TableRowCell>
              <TableRowCell>{userEmail}</TableRowCell>
              <TableRowCell>
                {campers.map(camper => {
                  return getCamperInfo(camper) + "; "
                })}
              </TableRowCell>
              <TableRowCell>
                <EmailUserButton onClick={() => {}}>Email User</EmailUserButton>
                <ArchiveRequest
                  onClick={() => this.archiveOrActivate(row.id, filter)}
                >
                  {filter === "active" ? "Archive" : "Activate"}
                </ArchiveRequest>
              </TableRowCell>
            </TableRow>
          )
        })}
      </TableBody>
    )
  }

  render() {
    const data = this.props.data.data
    const included = this.props.data.included

    return (
      <HeaderTabContainer default="/info_requests" mountPath="/info_requests">
        <HeaderTab key={0} title="Active" path={`/info_requests/active`}>
          {this.renderInfoRequestTable(data, included, "active")}
        </HeaderTab>
        <HeaderTab key={1} title="Archived" path={`/info_requests/archived`}>
          {this.renderInfoRequestTable(data, included, "archived")}
        </HeaderTab>
      </HeaderTabContainer>
    )
  }
}

export default withRouter(CampInfoRequestsLoaded)



// WEBPACK FOOTER //
// ./src/scenes/Camp/CampInfoRequests/CampInfoRequests.js